// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'einaSemiBold', 'einaSemiBold Fallback'","fontWeight":400,"fontStyle":"normal"},"className":"__className_bb3067","variable":"__variable_bb3067"};